import { px2rem } from '@moim/common';
import { css } from 'styled-components';

var getPaddingStyle = function getPaddingStyle(padding) {
  var style = css([""]);
  if (!padding) return style;
  if (padding.top !== undefined) {
    style = style.concat(css(["padding-top:", ";"], px2rem(padding.top)));
  }
  if (padding.bottom !== undefined) {
    style = style.concat(css(["padding-bottom:", ";"], px2rem(padding.bottom)));
  }
  if (padding.left !== undefined) {
    style = style.concat(css(["padding-left:", ";"], px2rem(padding.left)));
  }
  if (padding.right !== undefined) {
    style = style.concat(css(["padding-right:", ";"], px2rem(padding.right)));
  }
  return style;
};
var blockAlign2FlexAlign = function blockAlign2FlexAlign(align) {
  if (align === "left") {
    return "flex-start";
  }
  if (align === "center") {
    return "center";
  }
  if (align === "right") {
    return "flex-end";
  }
};
var blockVerticalAlign2FlexAlign = function blockVerticalAlign2FlexAlign(align) {
  if (align === "top") {
    return "flex-start";
  }
  if (align === "center") {
    return "center";
  }
  if (align === "bottom") {
    return "flex-end";
  }
};

export { blockAlign2FlexAlign, blockVerticalAlign2FlexAlign, getPaddingStyle };
